import JSONParser from '../helper/json-parser';
import Logger from './logger';

const UID = 'uid';
const CURRENT_WINDOW = 'currentWindow';
const NEXT_LOADING_WINDOW_DATA = 'nextLoadingWindowData';
const ONE_HOUR_MILLISECONDS = 3600000;

function initialize() {
    let tabData = {};
    if(!getCurrentTabId()) {
        setNewTabId();
        if(isAnotherTabOpen()) {
            tabData = getTabDataFromPreviousTab();
        }
    } else {
        tabData = getCurrentTabData();
    }

    const dataForNextLoadingTab = getDataForNextLoadingTab();
    for (const keyOfVariable in dataForNextLoadingTab) {
        tabData[keyOfVariable] = dataForNextLoadingTab[keyOfVariable];
    }
    removeNextLoadingTabData();

    setCurrentTabData(tabData);
    setCurrentWindow(getCurrentTabId());

    window.addEventListener('beforeunload', cleanUpStorage);
}

export default {
    initialize,
    getCurrentTabId,
    getCurrentTabData,
    setSpecificTabDataItem,
};

function getCurrentTabId () {
    return window.sessionStorage[UID];
}

function setNewTabId() {
    window.sessionStorage[UID] = generateUID();
}

function generateUID() {
    return UID + (Math.floor((Math.random() * 99999999) + 1));
}

function getTabDataFromPreviousTab() {
    const currentWindowUid = window.localStorage[CURRENT_WINDOW];
    return window.localStorage[currentWindowUid] ? JSONParser.tryParseJSON(window.localStorage[currentWindowUid]) : {};
}

function getCurrentTabData() {
    return getDataForWindowId(getCurrentTabId());
}

function setCurrentTabData(tabData) {
    tabData.timestamp = new Date();
    window.localStorage[getCurrentTabId()] = JSON.stringify(tabData);
}

function setSpecificTabDataItem(key, value) {
    const tabData = getCurrentTabData();
    tabData[key] = value;
    setCurrentTabData(tabData);
}

function getDataForWindowId(uid) {
    return window.localStorage[uid] ? JSONParser.tryParseJSON(window.localStorage[uid]) : {};
}

function getDataForNextLoadingTab() {
    return window.localStorage[NEXT_LOADING_WINDOW_DATA] ? JSONParser.tryParseJSON(window.localStorage[NEXT_LOADING_WINDOW_DATA]) : {};
}

function removeNextLoadingTabData() {
    window.localStorage.removeItem(NEXT_LOADING_WINDOW_DATA);
}

function getCurrentWindow() {
    return window.localStorage[CURRENT_WINDOW];
}

function setCurrentWindow(tabId) {
    window.localStorage[CURRENT_WINDOW] = tabId;
}

function isAnotherTabOpen() {
    return getCurrentWindow() !== undefined;
}

function cleanUpStorage() {
    const currentTime = new Date();
    for (const key in window.localStorage) {
        if (window.localStorage.hasOwnProperty(key)) {
            try {
                const value = window.localStorage.getItem(key);
                const storageObject = value ? JSONParser.tryParseJSON(value) : {};
                if (storageObject.timestamp) {
                    const tabDataTimestamp = new Date(storageObject.timestamp);
                    if ((currentTime - tabDataTimestamp) > ONE_HOUR_MILLISECONDS) {
                        window.localStorage.removeItem(key);
                    }
                }
            } catch (e) {
                Logger.debug('[WINDOW_MANAGER] can\'t clear storage' + e);
            }
        }
    }
}
